import { createFileRoute } from "@tanstack/react-router";
import FindAVerifiedSaintProviderGoogle from "@/pages/FindAVerifiedSaintProviderGoogle";
export const Route = createFileRoute("/find-a-verified-saint-provider-google")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "Find a Verified SAINT® Provider | Neuro Wellness TMS Centers",
        },
        {
          name: "description",
          content:
            "Verify an authorized SAINT® TMS provider. See Neuro Wellness TMS Centers of America's official Magnus Medical listing, treatment suites, and clinic photos.",
        },
        {
          property: "og:title",
          content:
            "Find a Verified SAINT® Provider | Neuro Wellness TMS Centers",
        },
        {
          property: "og:description",
          content:
            "Verify an authorized SAINT® TMS provider. See Neuro Wellness TMS Centers of America's official Magnus Medical listing, treatment suites, and clinic photos.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/find-a-verified-saint-provider-google",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/find-a-verified-saint-provider-google",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FindAVerifiedSaintProviderGoogle />;
}
